import { graphql } from "@cappelendamm/crystallize-types/search/gql";
export const getProductPathBySku = async ({ skus }, { client }) => {
    const data = await client.search.request(graphql(`
      query GetProductBySku($skus: [String!]) {
        search(
          language: "no-nb"
          filter: { type: PRODUCT, include: { skus: $skus } }
        ) {
          edges {
            node {
              name
              path
            }
          }
        }
      }
    `), { skus: skus, tenantId: client.tenantId });
    if (!data.search.edges?.length)
        throw new Error(`No product found for: ${skus}`);
    return data.search.edges?.map(({ node }) => {
        return {
            name: node.name,
            path: node.path,
        };
    });
};
